"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getThingJson(thing) {
    const { name, image, url, description, identifier } = thing;
    let thingJson = `{
    "@type": "Thing",
    "name": "${name}",
    "image": "${image}",
    "url": "${url}",
    "description": "${addslashes(description)}",
  `;
    if (typeof identifier === 'number') {
        thingJson += `"identifier": ${identifier}`;
    }
    else {
        thingJson += `"identifier": "${identifier}"`;
    }
    thingJson += '}';
    return thingJson;
}
exports.getThingJson = getThingJson;
function getOfferJson(offer) {
    let offerJson = `{
      "@type": "Offer",
      "availability": "${offer.availability}",
      "price": "${offer.price}",
      "priceCurrency": "${internationalCurrencyAbbreviation(offer.priceCurrency)}"
    `;
    if (offer.url) {
        offerJson += `, "url": "${offer.url}"`;
    }
    if (offer.itemOffered) {
        offerJson += `
      ,"itemOffered": ${getThingJson(offer.itemOffered)}
    `;
    }
    if (offer.itemCondition) {
        offerJson += `
      ,"itemCondition": "${offer.itemCondition}"
    `;
    }
    offerJson += '}';
    return offerJson;
}
exports.getOfferJson = getOfferJson;
function getOrganizationJson(organization) {
    return '';
}
exports.getOrganizationJson = getOrganizationJson;
function getPersonJson(person) {
    const { name, email, identifier, image, url } = person;
    const personJson = `{
    "@type": "Person",
    "name": "${name}",
    "email": "${email}",
    "image": "${image}",
    "url": "${url}",
    "identifier": "${identifier}"
  }
  `;
    return personJson;
}
exports.getPersonJson = getPersonJson;
function getContactPointJson(contactPoint) {
    const { telephone, contactType } = contactPoint;
    return `{
    "@type": "ContactPoint",
    "telephone": "${telephone}",
    "contactType": "${contactType}"
  }`;
}
exports.getContactPointJson = getContactPointJson;
function getBrandJson(brandName) {
    return `{
    "@type": "Brand",
    "name": "${brandName}"
  }`;
}
exports.getBrandJson = getBrandJson;
function getImageObjectJson(imageObject) {
    const imageObjectObject = Object.assign(Object.assign({ '@type': 'ImageObject', url: imageObject.url }, (imageObject.width ? { width: `${imageObject.width}` } : {})), (imageObject.height ? { height: `${imageObject.height}` } : {}));
    return JSON.stringify(imageObjectObject);
}
exports.getImageObjectJson = getImageObjectJson;
function getVideoObjectJson(videoObject) {
    const videoObjectObject = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ '@type': 'VideoObject', contentUrl: videoObject.contentUrl }, (videoObject.duration ? { duration: `${videoObject.duration}` } : {})), (videoObject.name ? { name: `${videoObject.name}` } : {})), (videoObject.thumbnailUrl
        ? { thumbnailUrl: `${videoObject.thumbnailUrl}` }
        : {})), (videoObject.description || videoObject.description === ''
        ? { description: `${videoObject.description}` }
        : {})), (videoObject.uploadDate
        ? { uploadDate: `${videoObject.uploadDate}` }
        : {}));
    return JSON.stringify(videoObjectObject);
}
exports.getVideoObjectJson = getVideoObjectJson;
/* Utilitná funkcia pre získanie mediznárdonej skratky menu
 * @param currency - skratka meny používana na nashom eshope
 * @return - návratovou hodnotou je medinárodná skratka meny
 */
function internationalCurrencyAbbreviation(currency) {
    switch (currency) {
        case 'LEI':
        case 'Lei':
        case 'lei':
            return 'RON';
        default:
            return currency;
    }
}
exports.internationalCurrencyAbbreviation = internationalCurrencyAbbreviation;
exports.toArray = (value) => {
    if (Array.isArray(value)) {
        return value;
    }
    else {
        return [value];
    }
};
function addslashes(str) {
    return (str + '')
        .replace(/\n/g, '')
        .replace(/[\\"]/g, '\\$&')
        .replace(/\u0000/g, '\\0');
}
exports.addslashes = addslashes;
